export const GRANT_DETAILS_SKELETON_FIELDS = [
  "token-type",
  "total-supply",
  "floor-price",
  "tokens-granted",
  "tdh-rate",
  "valid-from",
] as const;
